var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{attrs:{"type":_vm.buttonType,"disabled":_vm.disabled},on:{"click":_vm.click}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('app.export')))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }